const createVisibilityObserver = (onCardVisible, cardName) => {
  let observer = null;
  let hasCalled = false;
  return node => {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
    if (node && onCardVisible) {
      observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !hasCalled) {
            hasCalled = true;
            onCardVisible(cardName);
          }
        });
      }, {
        threshold: 1
      });
      observer.observe(node);
    }
  };
};

export { createVisibilityObserver as c };
//# sourceMappingURL=createVisibilityObserver-C8NVlrp5.js.map
